module.exports = __webpack_public_path__ + "img/free.757aca8f.jpg";